import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热播榜单</h2>
        <p className="text-sm text-foreground-500 mb-10">实时更新的热度排行，看看大家都在追什么</p>
        <div className="max-w-2xl flex flex-col gap-2">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-extrabold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  {item.trend === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-green-100 text-green-700 whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.type}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-green-500 text-sm"></i>
                )}
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}